import { createStore } from 'zustand/vanilla'
import { persist } from 'zustand/middleware'

export type UserState = {
  isLogin: boolean
  name: string
  email: string
  token: string
  sex: number
  currency: string
  currencySign: string
  exchangeRate: number
  cartNum: number
  bookIdList: number[]
  isGoToRate: boolean
}

export type UserActions = {
  updateIsLogin: (isLogin: boolean) => void
  updateName: (name: string) => void
  updateEmail: (email: string) => void
  updateToken: (token: string) => void
  updateSex: (sex: number) => void
  updateCurrency: (currency: string) => void
  updateCurrencySign: (currencySign: string) => void
  updateExchangeRate: (exchangeRate: number) => void
  updateCartNum: (cartNum: number) => void
  updateBookIdList: (bookIdList: number[]) => void
  updateIsGoToRate: (isGoToRate: boolean) => void
}

export type UserStore = UserState & UserActions

export const defaultInitState: UserState = {
  isLogin: false,
  name: '',
  email: '',
  token: '',
  sex: 0,
  currency: 'CNY',
  currencySign: '¥',
  exchangeRate: 0,
  cartNum: 0,
  bookIdList: [],
  isGoToRate: false
}

export const createUserStore = (initState: UserState = defaultInitState) => {
  return createStore<UserStore>()(
    persist(
      (set) => ({
        ...initState,
        updateName: (name: string) => set((state) => ({ name })),
        updateEmail: (email: string) => set((state) => ({ email })),
        updateToken: (token: string) => set((state) => ({ token })),
        updateSex: (sex: number) => set((state) => ({ sex })),
        updateIsLogin: (isLogin: boolean) => set((state) => ({ isLogin })),
        updateCurrency: (currency: string) => set((state) => ({ currency })),
        updateCurrencySign: (currencySign: string) => set((state) => ({ currencySign })),
        updateExchangeRate: (exchangeRate: number) => set((state) => ({ exchangeRate })),
        updateCartNum: (cartNum: number) => set((state) => ({ cartNum })),
        updateBookIdList: (bookIdList: number[]) => set((state) => ({ bookIdList })),
        updateIsGoToRate: (isGoToRate: boolean) => set((state) => ({ isGoToRate }))
      }),
      { name: 'userStore', partialize: (state) => state }
    )
  )
}
